import Default from '../layout/Default.vue';
import patient from './index.patient';
import clinicalRecruitment from './index.clinicalRecruitment';
import projectManage from './index.projectManage';
import messageCommunicate from './index.messageCommunicate';
import account from './index.account';
import inHospital from './index.inHospital';
import familyDoctor from './index.familyDoctor';
import home from './index.home';
import configStatistics from './index.configStatistics';
import preInquiry from './index.preInquiry';
import scientificTools from './index.scientificTools';
export default [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: 'login' */ '../views/patient/login.vue'),
  },
  {
    path: '/authorization',
    name: 'authorization',
    component: () => import(/* webpackChunkName: 'authorization' */ '../views/patient/authorization.vue'),
  },
  {
    // WorkBuddy OAuth 2.1 授权确认页（用户点【允许/拒绝】）
    // 后端 GET /oauth/authorize 未登录 302 到 /#/login?redirect=...，登录成功再回到这里
    path: '/oauth/consent',
    name: 'oauthConsent',
    component: () => import(/* webpackChunkName: 'oauthConsent' */ '../views/patient/oauthConsent.vue'),
  },
  {
    path: '/his',
    name: 'his',
    component: () => import(/* webpackChunkName: "his" */ '../views/patient/detail/his.vue'),
  },
  {
    path: '/preInquiryHis',
    name: 'preInquiryHis',
    component: () => import(/* webpackChunkName: "preInquiryHis" */ '../views/preInquiry/his.vue'),
  },
  {
    path: '/qianfan',
    name: 'qianfan',
    component: () => import(/* webpackChunkName: 'qianfan' */ '../views/qianfan/index.vue'),
  },
  {
    path: '/sso',
    name: 'sso',
    component: () => import(/* webpackChunkName: 'sso' */ '../views/sso/index.vue'),
  },
  {
    path: '/matchResult',
    name: 'matchResult',
    component: () => import(/* webpackChunkName: 'matchResult' */ '../views/clinicalTestMatchResults/list/index.vue'),
  },
  {
    path: '/matchResult/detail',
    name: 'matchResultDetail',
    component: () => import(/* webpackChunkName: 'matchResultDetail' */ '../views/clinicalTestMatchResults/detail/index.vue'),
  },
  {
    path: '/shareMaterial',
    name: 'shareMaterial',
    component: () => import(/* webpackChunkName: 'shareMaterial' */ '../views/patient/detail/share.vue'),
  },
  {
    path: '/qw/msg',
    name: 'qwMsg',
    component: () => import(/* webpackChunkName: 'qwMsg' */ '../views/qw-sidebar/message-template/index.vue'),
  },
  {
    path: '/qw/timeline',
    name: 'qwTimeline',
    component: () => import(/* webpackChunkName: 'qwMsg' */ '../views/qw-sidebar/timeline/index.vue'),
  },
  {
    path: '/qw/ai',
    name: 'qwAI',
    component: () => import(/* webpackChunkName: 'qwMsg' */ '../views/qw-sidebar/AI/index.vue'),
  },

  // ===== 彩蛋：debug 调试台（仅测试环境使用，双击 logo 触发）=====
  {
    path: '/debug/tools',
    name: 'debug-tools',
    component: () => import(/* webpackChunkName: 'debug' */ '../views/debug/ToolDebugView.vue'),
  },
  {
    path: '/debug/batch',
    name: 'debug-batch',
    component: () => import(/* webpackChunkName: 'debug' */ '../views/debug/BatchTestView.vue'),
  },
  {
    path: '/default',
    component: Default,
    children: [
      ...patient,
      ...clinicalRecruitment,
      ...projectManage,
      ...messageCommunicate,
      ...account,
      ...inHospital,
      ...familyDoctor,
      ...home,
      ...configStatistics,
      ...preInquiry,
      ...scientificTools,
    ],
  },
];
